/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { SubscriptionAnalytics } from "../models/subscription-analytics";
@Injectable({
  providedIn: "root",
})
class SubscriptionStatisticsService extends __BaseService {
  static readonly subscriptionStatisticsGetBaseSubscriptionStatisticsPath =
    "/GetSubscriptionBaseStats";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param subscriptionId undefined
   */
  subscriptionStatisticsGetBaseSubscriptionStatisticsResponse(
    subscriptionId?: number
  ): __Observable<__StrictHttpResponse<SubscriptionAnalytics>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (subscriptionId != null)
      __params = __params.set("subscriptionId", subscriptionId.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/GetSubscriptionBaseStats`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SubscriptionAnalytics>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  subscriptionStatisticsGetBaseSubscriptionStatistics(
    subscriptionId?: number
  ): __Observable<SubscriptionAnalytics> {
    return this.subscriptionStatisticsGetBaseSubscriptionStatisticsResponse(
      subscriptionId
    ).pipe(__map((_r) => _r.body as SubscriptionAnalytics));
  }
}

module SubscriptionStatisticsService {}

export { SubscriptionStatisticsService };
